
import React from 'react'
import { SETUP_PAYMENT } from '../../Apollo/graphql/Mutation/SetupPayment';
import { PrimaryButtonX } from '../../Components/Button3D';
import FooterPublic3D from '../../Components/FooterPublic3D';
import HeaderComponent from '../../Components/HeaderComponents';
import { getUserData } from '../../utils/utilsFunctions';
import { useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/client';

// import styled from 'styled-components';

const BecomeASellerPage = () => {
    const history = useHistory();
    const user = JSON.parse(getUserData('user'))
    const isSeller = user?.isSeller === true;
    const isPaymentSetUpComplete = user?.paymentSetupComplete === true;
    const [setupPayment] = useMutation(SETUP_PAYMENT);

   
    

    const handleStripeAccount = async () => {

        const data: any = await setupPayment();
        if (data && data.data.setupPayment) {
            window.location.replace(data.data.setupPayment.url);
        }

    };


    return (
        <div style={{ background: 'white' }}>
            <HeaderComponent />
            <div style={{ height: '300px' }}>
                <h1 style={{ textAlign: 'center', paddingTop: '6rem' }}>Start Selling from Today</h1>
                {
                    isSeller ? (
                    !isPaymentSetUpComplete ? <p style={{ textAlign: 'center', marginTop: '2rem' }}>
                        <PrimaryButtonX type='primary' onClick={() => handleStripeAccount()}>Join payment</PrimaryButtonX>
                    </p> : <p style={{ textAlign: 'center', marginTop: '2rem' }}>
                        <PrimaryButtonX type='primary' onClick={() => history.push("/")}>start selling</PrimaryButtonX>
                    </p>
                    ) : ""
                }
            </div>
            <FooterPublic3D />
        </div>
    )
}

export default BecomeASellerPage